import {
  fetchBasketOrderDetails,
  createBasketOrderDetails,
  deleteBasketOrderDetails,
  addBasketInstrumentDetails,
  updateBasketInstrumentDetails,
  removeBasketInstrumentDetails,
  executeBasket,
  renameBasketName,
  updateBasketExecutionState
} from "../../services/backendAPI";

export const setBasketOrders = (basketOrders) => ({
  type: "SET_BASKET_ORDER",
  payload: basketOrders,
});

export const fetchBasketOrdersAction = () => async (dispatch) => {
  try {
    const response = await fetchBasketOrderDetails();
    if (response?.status === "success" || response?.success) {
      dispatch(setBasketOrders(response.data || []));
      return { status: "success", data: response.data };
    }
    return { status: "error", message: response?.message || "Failed to fetch baskets" };
  } catch (error) {
    console.error("Error fetching baskets:", error);
    return { status: "error", message: error.message || "Failed to fetch baskets" };
  }
};

export const createBasketAction = (payload) => async (dispatch) => {
  try {
    const response = await createBasketOrderDetails(payload);
    if (response?.status === "success" || response?.success) {
      // Re-fetch after creation
      dispatch(fetchBasketOrdersAction());
      return { status: "success", message: response.message, data: response.data };
    }
    return { status: "error", message: response?.message || "Failed to create basket" };
  } catch (error) {
    console.error("Error creating basket:", error);
    return { status: "error", message: error.message || "Failed to create basket" };
  }
};

export const deleteBasketAction = (payload) => async (dispatch) => {
  try {
    const response = await deleteBasketOrderDetails(payload);
    if (response?.status === "success" || response?.success) {
      dispatch(fetchBasketOrdersAction());
      return { status: "success", message: response.message };
    }
    return { status: "error", message: response?.message || "Failed to delete basket" };
  } catch (error) {
    console.error("Error deleting basket:", error);
    return { status: "error", message: error.message || "Failed to delete basket" };
  }
};

export const renameBasketAction = (payload) => async (dispatch) => {
  try {
    const response = await renameBasketName(payload);
    if (response?.status === "success" || response?.success) {
      dispatch(fetchBasketOrdersAction());
      return { status: "success", message: response.message };
    }
    return { status: "error", message: response?.message || "Failed to rename basket" };
  } catch (error) {
    console.error("Error renaming basket:", error);
    return { status: "error", message: error.message || "Failed to rename basket" };
  }
};

export const addBasketInstrumentAction = (payload) => async (dispatch) => {
  try {
    const response = await addBasketInstrumentDetails(payload);
    if (response?.status === "success" || response?.success) {
      dispatch(fetchBasketOrdersAction());
      return { status: "success", message: response.message };
    }
    return { status: "error", message: response?.message || "Failed to add instrument to basket" };
  } catch (error) {
    console.error("Error adding instrument to basket:", error);
    return { status: "error", message: error.message || "Failed to add instrument to basket" };
  }
};

export const updateBasketInstrumentAction = (payload) => async (dispatch) => {
  try {
    const response = await updateBasketInstrumentDetails(payload);
    if (response?.status === "success" || response?.success) {
      dispatch(fetchBasketOrdersAction());
      return { status: "success", message: response.message };
    }
    return { status: "error", message: response?.message || "Failed to modify instrument in basket" };
  } catch (error) {
    console.error("Error modifying instrument in basket:", error);
    return { status: "error", message: error.message || "Failed to modify instrument in basket" };
  }
};

export const removeBasketInstrumentAction = (payload) => async (dispatch) => {
  try {
    const response = await removeBasketInstrumentDetails(payload);
    if (response?.status === "success" || response?.success) {
      dispatch(fetchBasketOrdersAction());
      return { status: "success", message: response.message };
    }
    return { status: "error", message: response?.message || "Failed to remove instrument from basket" };
  } catch (error) {
    console.error("Error removing instrument from basket:", error);
    return { status: "error", message: error.message || "Failed to remove instrument from basket" };
  }
};

export const executeBasketAction = (payload) => async (dispatch) => {
  try {
    const response = await executeBasket(payload);
    if (response?.status === "success" || response?.success) {
      return { status: "success", message: response.message };
    }
    return { status: "error", message: response?.message || "Failed to execute basket" };
  } catch (error) {
    console.error("Error executing basket:", error);
    return { status: "error", message: error.message || "Failed to execute basket" };
  }
};

export const updateBasketExecutionStateAction = (payload) => async (dispatch) => {
  try {
    const response = await updateBasketExecutionState(payload);
    if (response?.status === "success" || response?.success) {
      await dispatch(fetchBasketOrdersAction());
      return { status: "success", message: response.message };
    }
    return { status: "error", message: response?.message || "Failed to update basket execution state" };
  } catch (error) {
    console.error("Error updating basket execution state:", error);
    return { status: "error", message: error.message || "Failed to update basket execution state" };
  }
};
